import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * Pay2MeComponent
 */
let Pay2MeComponent = class Pay2MeComponent {
    constructor() { }
    ngOnInit() {
    }
};
Pay2MeComponent = __decorate([
    Component({
        selector: 'ecd-pay2me',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./pay2me.component.html")).default
    })
], Pay2MeComponent);
export { Pay2MeComponent };
